// extracted by mini-css-extract-plugin
module.exports = {"centerblock":"Slide_centerblock__1NC2L","highlight":"Slide_highlight__4bp_j","slideText":"Slide_slideText__27Jh_","slideModule":"Slide_slideModule__360R_"};